<template>
  <div id="notify" :class="currentClasses" @click="internalClb">
    <i v-if="current.icon" class="fa fa-fw message-icon" :class="current.icon"></i>
    <div>{{current.text || '(no message)'}}</div>
    <div class="progress-radial" :class="progressClass" v-if="progressClass">
      <div class="overlay">{{progressValue}}%</div>
    </div>
    <button @click.stop="goNext" v-else :aria-label="isLast ? dictValue('Close') : dictValue('NextNotification')">
      <i class="fa fa-close" v-if="isLast">&nbsp;</i>
      <div v-else-if="count" class="next">{{count - 1}}<i class="fa fa-chevron-right">&nbsp;</i></div>
    </button>
  </div>
</template>

<script>
import internalBus from '@/internalBus'

export default {
  name: 'Notifier',
  data () {
    return {
      queue: [],
      changing: false,
      timeout: null
    }
  },
  computed: {
    current () {
      return this.queue.length ? this.queue[0] : {}
    },
    currentClasses () {
      if (!this.open) {
        return 'hide'
      }
      let classes = []
      if (this.current) {
        classes.push(this.current.type)
        if (this.current.clb) {
          classes.push('clickable')
        }
      }
      return classes.join(' ')
    },
    count () {
      return this.queue.length
    },
    isLast () {
      return this.queue.length === 1
    },
    open () {
      return !!this.queue.length && !this.changing
    },
    progressValue () {
      if (this.current && !isNaN(this.current.progress)) {
        return Math.floor(this.current.progress * 100)
      }
      return null
    },
    progressClass () {
      if (this.progressValue !== null) {
        return `progress-${this.progressValue === 100 ? 100 : this.progressValue % 100}`
      }
      return null
    }
  },
  methods: {
    internalClb () {
      if (this.current.clb) {
        this.current.clb()
        this.goNext()
      }
    },
    goNext () {
      this.changing = true
      setTimeout(() => {
        this.changing = false
        this.queue.shift()
      }, 300)
    },
    showProgress (payload) {
      this.show('progress', payload)
    },
    showError (payload) {
      this.show('error', payload)
    },
    showSuccess (payload) {
      this.show('success', payload)
    },
    showInfo (payload) {
      this.show('info', payload)
    },
    showWarning (payload) {
      this.show('warning', payload)
    },
    show (type, payload) {
      if (typeof payload === 'string') {
        payload = { text: payload }
      }
      payload.type = type
      if (!payload.timeout) {
        if (type === 'error') {
          payload.timeout = 5000
        } else if (type === 'warning') {
          payload.timeout = 4000
        } else if (type === 'progress') {
          payload.timeout = payload.progress >= 1 ? 1000 : null
        } else if (type !== 'error') {
          payload.timeout = 1800
        }
      }
      var replaced = false
      if (payload.key) {
        var index = this.queue.findIndex(q => q.key === payload.key)
        if (index > -1) {
          this.queue.splice(index, 1, payload)
          replaced = true
        }
      }
      if (!replaced) {
        this.queue.push(payload)
      }
      /* if (!this.timeout) {
        this.change()
      } */
    },
    /* change () {
      this.queue.shift()
      if (this.queue.length) {
        this.timeout = setTimeout(this.change, 3000)
      } else {
        this.timeout = null
      }
    } */
    hide (key) {
      if (key === this.current.key) {
        this.goNext()
      } else if (key) {
        var index = this.queue.findIndex(q => q.key === key)
        if (index > -1) {
          this.queue.splice(index, 1)
        }
      }
    }
  },
  mounted () {
    internalBus.$on('notify:error', this.showError)
    internalBus.$on('notify:success', this.showSuccess)
    internalBus.$on('notify:info', this.showInfo)
    internalBus.$on('notify:progress', this.showProgress)
    internalBus.$on('notify:warning', this.showWarning)
    internalBus.$on('notify:hide', this.hide)

    /* setTimeout(() => {
      internalBus.$emit('notify:error', 'Test')
    }, 3000)
    setTimeout(() => {
      internalBus.$emit('notify:success', 'Test 2')
    }, 5000) */
  },
  watch: {
    current (newV) {
      // console.log('current msg changed')
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      if (newV && newV.timeout) {
        this.timeout = setTimeout(this.goNext, newV.timeout)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.desktop #notify {
  left: initial;
}

#notify {
  position: fixed;
  bottom: .4rem;
  left: .5rem;
  right: .5rem;
  width: auto;
  z-index: 90000;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: .5rem;
  background-color: var(--black);
  color: var(--white);
  box-shadow: 0 0 5px --black, 0 0 10px --black;
  transition: all .3s ease;
  opacity: 1;
  will-change: transform, background-color, opacity;

  &.hide {
    transform: translateY(110%);
    box-shadow: 0 0 0 --black;
    opacity: 0;
  }

  &.error {
    background-color: var(--red);
    color: var(--white);
  }
  &.warning {
    background-color: var(--orange);
    color: var(--black);
  }
  /* &.info {
    // default
  }
  &.progress {
    // default
  } */
  &.success {
    background-color: var(--green);
    color: white;
  }

  button {
    background-color: transparent;
    border-color: transparent;
    color: inherit;
    box-shadow: none;
  }

  .message-icon {
    font-size: 3.5rem;
    position: absolute;
    bottom: -2rem;
    left: -0.2rem;
    background: inherit;
    border-radius: 50%;
    padding: 1rem;
    height: auto;
    width: auto;

    & + div {
      padding-left: 5rem;
    }
  }

  .next {
    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      font-size: 0.9rem;
      margin-left: .3rem;
    }
  }

  $progressBgColor: var(--black);
  $progressFrColor: var(--white);
  $progressSize: 1.5rem;

  .progress-radial {
    float: left;
    margin-right: 30px;
    position: relative;
    width: $progressSize;
    height: $progressSize;
    border-radius: 50%;
    border: 1px solid $progressFrColor; // remove gradient color
    // background-color: $progressFrColor; // default 100%
    // transition: transform .3s ease;

    .overlay {
      display: none;
    }
  }

  $step: 1; // step of % for created classes
  $loops: round(100 / $step);
  $increment: 360 / $loops;
  $half: round($loops / 2);
  @for $i from 0 through $loops {
    .progress-#{$i*$step} {
      @if $i < $half {
        $nextdeg: 90deg + ( $increment * $i );
        background-image: linear-gradient(90deg, $progressBgColor 50%, transparent 50%, transparent), linear-gradient($nextdeg, $progressFrColor 50%, $progressBgColor 50%, $progressBgColor);
      } @else {
        $nextdeg: -90deg + ( $increment * ( $i - $half ) );
        background-image: linear-gradient($nextdeg, $progressFrColor 50%, transparent 50%, transparent), linear-gradient(270deg, $progressFrColor 50%, $progressBgColor 50%, $progressBgColor);
      }
    }
  }

  .progress-100 {
    animation-name: zoom-and-out;
    animation-duration: .5s;
    animation-fill-mode: forwards;
  }
}

@keyframes zoom-and-out {
  from {transform: scale(1);}
  30% {transform: scale(1.25);}
  to {transform: scale(0.01);}
}
</style>
